import { useRef, useEffect } from 'react';

export const useBold = (searchValue) => {
  const elementRef = useRef(null);
  const elementRefs = useRef([]);

  useEffect(() => {
    // Remove stale elements
    elementRefs.current = elementRefs.current.filter((el) => !!el);

    // Wrap search value with bold tags for multiple refs
    elementRefs.current.forEach((el) => {
      if (!el.innerHTML.match('<b>' + searchValue.source + '</b>')?.length) {
        // eslint-disable-next-line no-param-reassign
        el.innerHTML = el.innerHTML.replace(searchValue, '<b>$&</b>');
      }
    });

    // Wrap search value with bold tags for single ref
    if (elementRef.current) {
      if (!elementRef.current.innerHTML.match('<b>' + searchValue.source + '</b>')?.length) {
        elementRef.current.innerHTML = elementRef.current.innerHTML.replace(searchValue, '<b>$&</b>');
      }
    }
  });

  return {
    boldRef: elementRef,
    boldRefs: elementRefs,
  };
};
